import { RoleType } from 'app/store/reducer/requestflow'
import { get } from 'app/utils/axios/kheti'

export interface RequestTypesResponse {
  id: number
  name: string
  request_type: string[]
}

const fetchRequestTypes = async (
  roleType: RoleType,
): Promise<RequestTypesResponse | null> => {
  try {
    const response = await get<RequestTypesResponse>(
      '/approvals/v1/user/request-type',
      { role_type: roleType },
    )
    return response
  } catch (e) {
    console.log('Error fetching request types:', e)
    return null
  }
}

export default fetchRequestTypes
